class ImagesSliderSection extends HTMLElement {
  connectedCallback() {
    if (this._initialized) return;
    this._initialized = true;

    this._sectionId = this.dataset.sectionId;
    this._slideCount = parseInt(this.dataset.slideCount, 10) || 0;
    this._swiperEl = this.querySelector('.images-slider__swiper');
    this._navEl = this.querySelector('.images-slider__nav');
    this._prevBtn = this.querySelector('.images-slider__nav--prev');
    this._nextBtn = this.querySelector('.images-slider__nav--next');
    this._paginationEl = this.querySelector('.images-slider__pagination');

    if (window.ResizeObserver) {
      this._resizeObserver = new ResizeObserver(() =>
        this._updateNavPosition()
      );
      this._resizeObserver.observe(this);
    }

    if (!this._swiperEl || this._slideCount < 1) return;

    if ('IntersectionObserver' in window) {
      this._observer = new IntersectionObserver(
        entries => {
          if (entries[0].isIntersecting) {
            this._init();
            this._observer.disconnect();
          }
        },
        { rootMargin: '100px' }
      );
      this._observer.observe(this);
    } else {
      this._init();
    }
  }

  disconnectedCallback() {
    if (this._resizeObserver) this._resizeObserver.disconnect();
    if (this._observer) this._observer.disconnect();
    if (this._swiper) {
      this._swiper.destroy(true, true);
      this._swiper = null;
    }
  }

  _init() {
    if (typeof Swiper === 'undefined') {
      window.addEventListener('load', () => this._init(), { once: true });
      return;
    }
    if (this._swiper) return;

    const loop = this._slideCount >= 2;

    this._swiper = new Swiper(this._swiperEl, {
      slidesPerView: 1.1,
      spaceBetween: 16,
      loop,
      speed: 600,
      watchOverflow: true,
      breakpoints: {
        570: { slidesPerView: 2.15 },
        1024: { slidesPerView: 2.55 },
        1440: { slidesPerView: 3.1 },
        1920: { slidesPerView: 4.1 }
      },
      navigation: {
        prevEl: this._prevBtn,
        nextEl: this._nextBtn
      },
      a11y: {
        // Swiper builds this label from the DOM slide count, which is padded with
        // repeated cards here, so the announced total would overstate the real one.
        slideLabelMessage: null
      },
      pagination: {
        el: this._paginationEl,
        clickable: true,
        type: 'bullets'
      },
      on: {
        lock: () => this._toggleNav(true),
        unlock: () => this._toggleNav(false),
        afterInit: swiper => {
          this._toggleNav(swiper.isLocked);
          this._syncPagination();
          this._updateNavPosition();
        },
        slideChange: () => {
          this._syncPagination();
        },

        touchEnd: swiper => {
          this._trackScroll(swiper);
        },

        navigationNext: swiper => {
          this._trackScroll(swiper);
        },

        navigationPrev: swiper => {
          this._trackScroll(swiper);
        }
      }
    });
  }

  _syncPagination() {
    if (!this._paginationEl || !this._swiper) return;
    const bullets = this._paginationEl.querySelectorAll(
      '.swiper-pagination-bullet'
    );
    const realIdx = this._swiper.realIndex % this._slideCount;

    bullets.forEach((bullet, index) => {
      if (index >= this._slideCount) {
        bullet.style.display = 'none';
      } else {
        bullet.style.display = '';
        bullet.classList.toggle(
          'swiper-pagination-bullet-active',
          index === realIdx
        );
      }
    });
  }

  _trackScroll(swiper) {
    if (typeof calculateScrollPercentage === 'function') {
      calculateScrollPercentage(
        swiper,
        `#shopify-section-${this._sectionId} h2`,
        this._slideCount
      );
    }
  }

  _toggleNav(hidden) {
    if (this._navEl) this._navEl.style.display = hidden ? 'none' : '';
  }

  _updateNavPosition() {
    if (!this._navEl) return;
    const media = this.querySelector('.images-slider__media');
    if (!media) return;
    this._navEl.style.top = media.offsetHeight / 2 + 'px';
  }
}

if (!customElements.get('images-slider-section')) {
  customElements.define('images-slider-section', ImagesSliderSection);
}
